import {IEmploymentProps} from "@my-pages/features/employment/types";
import Employment from "@my-pages/features/employment/components/Employment/Employment.tsx";

const CurrentEmployment = ({ employment }: IEmploymentProps) => {
    return (
        <div className='card border border-success border-2 h-100'>
            <div className='card-body'>
                <div className='kicker mb-2'>Nuvarande arbetsgivare och adress</div>
                <Employment employment={employment} />
            </div>
        </div>
    );
};

export default CurrentEmployment;
